export default class TokenExpiredError extends Error {
  name = 'TokenExpiredError';

  constructor(readonly message = 'Token is Expired') {
    super(message);
  }
}
